import { useQuery } from '@tanstack/react-query';
import { strapiFetchNavigationMenu } from '../../api/strapiNavigationMenu';
import { queryKeys } from '../queryKeys';

export function useNavigationMenuQuery(jwt: string | null) {
  return useQuery({
    queryKey: queryKeys.navigationMenu(jwt),
    queryFn: () => strapiFetchNavigationMenu(jwt!),
    enabled: Boolean(jwt),
    // Menu only changes on login / impersonate / permission edits — those already invalidate.
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
